import { withProperties } from "../../utils";
import withSwitchStateFactory from "../helpers/reducers/switch";
import { START_PROCESSING, STOP_PROCESSING } from "../helpers/actions";

export default function state() {
  const NAME = 'processing';
  const $state = Object.create(null);

  const $processing = withSwitchStateFactory.call(this, {
    actions: { on: START_PROCESSING, off: STOP_PROCESSING },
    initialState: false,
    key: 'processing'
  });

  const Reducer = $processing['processing'];

  // Augment $state with properties
  withProperties($state, {
    NAME,
    Reducer,
    actions: withProperties(Object.create(null), $processing.actions)
  });

  return (state = $state);
}
